import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import AgentoPage from './pages/AgentoPage';
import AgentoSuccessPage from './pages/AgentoSuccessPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import EulaPage from './pages/EulaPage';
import AboutPage from './pages/AboutPage';
import BillingPolicyPage from './pages/BillingPolicyPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/agento" element={<AgentoPage />} />
        <Route path="/success" element={<AgentoSuccessPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/agento/eula" element={<EulaPage />} />
        <Route path="/billing-policy" element={<BillingPolicyPage />} />
        <Route path="/refunds" element={<BillingPolicyPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
